import { graphql } from 'react-relay';

/**
 * Slice-7 cross-tenant summary: total vaults and accounts plus the free / paying /
 * complimentary buckets (disjoint — each subscription in exactly one, by entitlement)
 * and the per-plan breakdown with each plan's complimentary share. Lives in `relay/` (not a screen) so the
 * `graphql` tag stays in a Babel-transformed data module — screens stay
 * transform-free and unit-testable.
 */
export const platformSummaryQuery = graphql`
    query platformSummaryQuery {
        platformSummary {
            totalVaults
            totalAccounts
            freeSubscriptions
            paidSubscriptions
            complimentarySubscriptions
            planBreakdown {
                planName
                subscriptionCount
                complimentaryCount
            }
        }
    }
`;
